'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _angularSanitize = require('angular-sanitize');

var _angularSanitize2 = _interopRequireDefault(_angularSanitize);

require('angular-local-storage');

require('angular-animate');

require('angular-aria');

require('angular-material');

require('angular-messages');

var _angularPermission = require('angular-permission');

var _highcharts = require('highcharts');

var _highcharts2 = _interopRequireDefault(_highcharts);

var _exporting = require('highcharts/modules/exporting');

var _exporting2 = _interopRequireDefault(_exporting);

var _drilldown = require('highcharts/modules/drilldown');

var _drilldown2 = _interopRequireDefault(_drilldown);

require('highcharts-ng');

var _angularMaterialDataTable = require('angular-material-data-table');

var _angularMaterialDataTable2 = _interopRequireDefault(_angularMaterialDataTable);

require('ng-file-upload/dist/ng-file-upload');

require('zd.ame-lightbox/dist/ame-lightbox');

var _environment = require('environment');

var _environment2 = _interopRequireDefault(_environment);

var _root = require('./root.component');

var _root2 = _interopRequireDefault(_root);

var _common = require('./common/common.module');

var _common2 = _interopRequireDefault(_common);

var _components = require('./components/components.module');

var _components2 = _interopRequireDefault(_components);

var _materialTheme = require('./config/material-theme');

var _materialTheme2 = _interopRequireDefault(_materialTheme);

var _http = require('./config/http');

var _http2 = _interopRequireDefault(_http);

var _httpTransform = require('./config/http-transform');

var _httpTransform2 = _interopRequireDefault(_httpTransform);

var _permissions = require('./config/permissions/permissions.config');

var _permissions2 = _interopRequireDefault(_permissions);

require('./root.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _exporting2.default)(_highcharts2.default);
// import highchartsTheme from './config/highcharts-theme';

(0, _drilldown2.default)(_highcharts2.default);
// Highcharts.theme = highchartsTheme;
// Highcharts.setOptions(highchartsTheme);
window.Highcharts = _highcharts2.default; // necessary for https://github.com/highcharts/highcharts/issues/4994

exports.default = _angular2.default.module('root', [_angularUiRouter2.default, _angularSanitize2.default, 'LocalStorageModule', 'ngMaterial', 'highcharts-ng', 'ngAnimate', 'ngMessages', 'ame.lightbox', 'ngFileUpload', _angularPermission.permission, _angularPermission.uiPermission, _angularMaterialDataTable2.default, _common2.default, _components2.default]).component('root', _root2.default).config(_materialTheme2.default).config(['$httpProvider', _http2.default]).config(['$httpProvider', _httpTransform2.default]).config(function ($locationProvider) {
  'ngInject';

  $locationProvider.html5Mode(true);
}).config(function ($compileProvider) {
  'ngInject';

  $compileProvider.debugInfoEnabled(_environment2.default.debugInfoEnabled);
  $compileProvider.preAssignBindingsEnabled(true);
}).run(_permissions2.default).run(function ($state, $transitions, LoadingService, ToastService) {
  'ngInject';

  $transitions.onStart({}, function (trans) {
    LoadingService.start();
    trans.promise.finally(function () {
      return LoadingService.stop();
    });
  });

  $state.defaultErrorHandler(function (error) {
    // Ignore transition errors
    if (error && error.message && error.message === 'The transition has been superseded by a different transition') {
      return;
    }

    ToastService.showError(error);
  });
}).name;


// WEBPACK FOOTER //
// ./root.module.js